import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, Grid, Breadcrumbs, Link, Tooltip, Typography, Select, MenuItem, TextField, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoomMaster, getRoomMasterData, getdrpRoomView } from '../../../../Api/RoomMst/Api';
import { getRoomMasterdropdata, GetBedCalendarMonthwise, GenerateBedCatCal, GetPropWiseBedCalendarMonth, updatebedcalender } from '../../../../Api/PropertyMst/Api'
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { getFormMode } from "../../../../lib/helpers";
import TableComponent from "../../../../atoms/TableComponent/Recordcalendertable";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { selectCurrentModulePermissions } from '../../../../redux/permissionsSlice';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import CrudButtons from '../../../../GlobalFunction/CrudButtons'
import {
  Edit as EditIcon,
  Save
} from '@mui/icons-material';
import { Delete as DeleteIcon } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux';
import {
  selectProperties,
  selectGlobalProperty,
  selectLocalProperty,
  setLocalProperty,
  fetchProperties,
  selectPropertyStatus
} from '../../../../redux/propertySlice';
import axiosInstance from '../../../../lib/axios';

const Form_Mode = getFormMode();

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const BASE_COLUMNS = [
  { id: 'RoomTypeName', label: 'Room Type', minWidth: 120 },
  { id: 'RoomBedTypeName', label: 'Bed Type', minWidth: 120 },
  { id: 'RoomViewName', label: 'View', minWidth: 70 },
  { id: 'BedRent', label: 'Rent', minWidth: 80 },
];

// Function to generate columns based on API response
const generateColumnsFromData = (apiData, startDate, endDate) => {
  const baseColumnWidths = {
    RoomTypeName: 120,
    RoomBedTypeName: 120,
    RoomViewName: 100,
    BedRent: 80,
  };

  const baseColumns = BASE_COLUMNS.map(col => ({
    ...col,
    minWidth: baseColumnWidths[col.id],
    maxWidth: baseColumnWidths[col.id],
    width: baseColumnWidths[col.id]
  }));

  // Extract unique month-year combinations from API data
  const monthColumns = new Set();

  if (apiData && apiData.length > 0) {
    apiData.forEach(item => {
      Object.keys(item).forEach(key => {
        // Check if key matches pattern "YYYY-MonthName"
        if (key.match(/^\d{4}-[A-Za-z]+$/)) {
          monthColumns.add(key);
        }
      });
    });
  }

  // Sort month columns chronologically
  const sortedMonthColumns = Array.from(monthColumns).sort((a, b) => {
    const [yearA, monthA] = a.split('-');
    const [yearB, monthB] = b.split('-');

    if (yearA !== yearB) {
      return parseInt(yearA) - parseInt(yearB);
    }

    const monthIndexA = MONTHS.findIndex(m => m === monthA);
    const monthIndexB = MONTHS.findIndex(m => m === monthB);
    return monthIndexA - monthIndexB;
  });

  // Generate columns with year headers
  const dynamicColumns = [];
  let currentYear = null;

  sortedMonthColumns.forEach(monthKey => {
    const [year, month] = monthKey.split('-');

    // Add year column if it's a new year
    if (currentYear !== year) {
      dynamicColumns.push({
        id: `year_${year}`,
        label: year,
        minWidth: 50,
        maxWidth: 50,
        width: 50,
        isYearColumn: true
      });
      currentYear = year;
    }

    // Add month column
    dynamicColumns.push({
      id: monthKey,
      label: month.substring(0, 3),
      minWidth: 60,
      maxWidth: 60,
      width: 60,
      isMonthColumn: true
    });
  });

  return [...baseColumns, ...dynamicColumns];
};

// Function to transform API data for table
const transformApiData = (apiData) => {
  if (!apiData || !Array.isArray(apiData)) {
    return [];
  }

  return apiData.map(item => {
    const transformedItem = {
      BedCatId: item.BedCatId,
      PropId: item.PropId,
      PropName: item.PropName,
      RoomTypeId: item.RoomTypeId,
      RoomTypeName: item.RoomTypeName,
      RoomViewName: item.RoomViewName || '',
      RoomBedTypeId: item.RoomBedTypeId,
      RoomBedTypeName: item.RoomBedTypeName,
      BedRent: item.BedRent,
    };

    // Add month data and year data
    Object.keys(item).forEach(key => {
      if (key.match(/^\d{4}-[A-Za-z]+$/)) {
        transformedItem[key] = item[key];

        const year = key.split('-')[0];
        transformedItem[`year_${year}`] = year;
      }
    });

    return transformedItem;
  });
};

export default function GenerateCalender(PropId, formMode) {
  const userId = sessionStorage.getItem('UserId');
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedPropId, setSelectedPropId] = useState(null);
  const [dateFrom, setDateFrom] = useState(dayjs());
  const [dateTo, setDateTo] = useState(dayjs().add(12, 'months'));
  const [tableColumns, setTableColumns] = useState(BASE_COLUMNS);
  const [isLoading, setIsLoading] = useState(false);
  const [editableData, setEditableData] = useState(new Map());
  const [selectedRoomBedIds, setSelectedRoomBedIds] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [pagination, setPagination] = useState({
    totalRecords: 0,
    currentPage: 1,
    totalPages: 0,
    pageSize: 180
  });
  const [form, setForm] = useState({
    PropId: "",
  });

  const dispatch = useDispatch();
  const properties = useSelector(selectProperties);
  const globalProperty = useSelector(selectGlobalProperty);
  const localProperty = useSelector(state => selectLocalProperty(state, 'calendar'));
  const propertyStatus = useSelector(selectPropertyStatus);
  const selectedProperty = localProperty || globalProperty;

  const [mode, setMode] = useState(() =>
    location?.state?.RoomId ? Form_Mode.read : Form_Mode.add
  );
  const permissions = usePermissions("Record Calendar");

  const handleDropdownChange = async (event) => {
    const selectedId = event.target.value;
    dispatch(setLocalProperty({
      componentId: 'calendar',
      propertyId: selectedId
    }));
    setForm(prevForm => ({
      ...prevForm,
      PropId: selectedId
    }));

    setIsEditMode(false);
    setSelectedRoomBedIds([]);
    setEditableData(new Map());

    if (!dateFrom || !dateTo) {
      return toast.error("Please select a date range");
    }

    try {
      setIsLoading(true);
      setRows([]);

      const payload = {
        PropId: selectedId,
        BookDtFrom: dateFrom.format("YYYY-MM-DD"),
        CheckoutDt: dateTo.format("YYYY-MM-DD"),
        Flag: ""
      };

      // Call fetchData with the new payload structure
      //   await fetchData("");

    } catch (error) {
      toast.error("Failed to fetch data");
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditMode(false);
    setSelectedRoomBedIds([]);
    setEditableData(new Map());
    fetchData("");
  };

  const fetchData = async (Flag) => {
    // Validate dates before API call
    if (!validateDateRange(dateFrom, dateTo)) {
      return;
    }

    if (!selectedProperty) {
      return toast.error("Please select a property");
    }

    try {
      setIsLoading(true);
      setRows([]);

      const payload = {
        PropId: selectedProperty,
        BookDtFrom: dateFrom.format("YYYY-MM-DD"),
        CheckoutDt: dateTo.format("YYYY-MM-DD"),
        Flag: Flag || ""
      };

      const response = await GenerateBedCatCal(payload);

      if (response?.data?.Status === 0) {
        const apiData = response.data.Data?.BedCatCalList || [];

        // Generate columns based on API response
        const newColumns = generateColumnsFromData(apiData, dateFrom, dateTo);
        setTableColumns(newColumns);

        // Transform API data for table
        const transformedData = transformApiData(apiData);
        setRows(transformedData);

        setPagination(prev => ({
          ...prev,
          totalRecords: transformedData.length,
          totalPages: Math.ceil(transformedData.length / prev.pageSize)
        }));
      } else {
        toast.error(response?.data?.Message || "Error fetching data");
      }
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (columnId, value) => {
    if (columnId === 'generalSearch') {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }

      // Only search if at least 3 characters are entered
      if (value.length >= 3 || value.length === 0) {
        searchTimeoutRef.current = setTimeout(() => {
          fetchData("");
        }, 1000);
      }
    } else {
      setSearchTerms(prev => ({ ...prev, [columnId]: value }));
      setPage(0);
    }
  };

  const searchTimeoutRef = useRef(null);

  // Clean up the timeout when component unmounts
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // Handle page change
  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, currentPage: newPage }));
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newPageSize) => {
    setPagination(prev => ({
      ...prev,
      pageSize: newPageSize,
      currentPage: 1 // Reset to first page when changing page size
    }));
  };

  useEffect(() => {
  }, [userId]);

  const handleDateFromChange = (newDate) => {
    setDateFrom(newDate);

    // Always auto-set dateTo to 12 months from dateFrom when dateFrom changes
    if (newDate && newDate.isValid()) {
      const newDateTo = newDate.add(12, 'months');
      setDateTo(newDateTo);
    }
  };

  const handleDateToChange = (newDate) => {
    setDateTo(newDate);
  };

  // Add validation function that will be called when Get Data button is clicked
  const validateDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      toast.error('Please select both From Date and To Date');
      return false;
    }

    if (!fromDate.isValid() || !toDate.isValid()) {
      toast.error('Please enter valid dates');
      return false;
    }

    const monthsDiff = toDate.diff(fromDate, 'month');

    if (monthsDiff < 0) {
      toast.error('To Date cannot be earlier than From Date');
      return false;
    }

    if (monthsDiff > 12) {
      toast.error('Date range cannot exceed 12 months');
      return false;
    }

    return true;
  };

  const handleGenerateClick = async () => {
    if (!selectedProperty) {
      return toast.error("Please select a property");
    }

    try {
      const payload = {
        PropId: selectedProperty,
        Flag: ""
      };

      await Promise.all([
        axiosInstance.post('BedCalendar/InsertBedCat', payload),
        axiosInstance.post('BedCalendar/InsertBedCatCal', payload),
        axiosInstance.post('BedCalendar/UpdateBedCat', payload),
        axiosInstance.post('BedCalendar/UpdateBedCatCal', payload),
        axiosInstance.post('BedCalendar/UpdateBedCatCal_Data', payload),
      ]);
      toast.success("Data refreshed successfully.");
      await fetchData("");  // Refresh data after successful generation
    } catch (error) {
      toast.error("Error while refreshing the data." + error.message);
    }
  };

  const filteredRows = React.useMemo(() => {
    return rows?.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        return String(value).toLowerCase().includes(term.toLowerCase());
      });
    });
  }, [searchTerms, rows]);

  // Updated renderCell function for numeric values
  const renderCell = (value, columnId) => {
    if (columnId && columnId.startsWith('year_')) {
      return <div style={{ textAlign: 'center', fontWeight: 'bold' }}>{value}</div>;
    }

    // For month columns, show the number with appropriate styling
    if (columnId && columnId.match(/^\d{4}-[A-Za-z]+$/)) {
      const numValue = parseFloat(value);
      let backgroundColor = '';
      let textColor = '#000';

      // Color coding based on availability (you can adjust these rules)
      if (numValue === 0) {
        backgroundColor = '#ffebee'; // Light red for no availability
        textColor = '#c62828';
      } else if (numValue <= 2) {
        backgroundColor = '#fff3e0'; // Light orange for low availability
        textColor = '#ef6c00';
      } else if (numValue <= 5) {
        backgroundColor = '#f3e5f5'; // Light purple for medium availability
        textColor = '#7b1fa2';
      } else {
        backgroundColor = '#e8f5e8'; // Light green for good availability
        textColor = '#2e7d32';
      }

      return (
        <div style={{
          backgroundColor,
          color: textColor,
          textAlign: 'center',
          fontWeight: 'bold',
          padding: '4px',
          borderRadius: '4px',
          minHeight: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {numValue || 0}
        </div>
      );
    }

    // For base columns, return as is
    return value || '';
  };

  const formattedRows = React.useMemo(() => {
    return rows.map(row => {
      const newRow = { ...row };

      Object.keys(row).forEach(key => {
        if (!BASE_COLUMNS.find(col => col.id === key) && row[key] !== undefined) {
          newRow[key] = renderCell(row[key], key);
        }
      });

      return newRow;
    });
  }, [rows]);

  const Filters = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
        <FormControl sx={{ minWidth: 170 }}>
          <InputLabel id="property-select-label">Property</InputLabel>
          <Select
            labelId="property-select-label"
            value={selectedProperty || ''}
            onChange={handleDropdownChange}
            label="Property"
            sx={{ height: "40px" }}
          >
            {properties.map((item) => (
              <MenuItem key={item.Id} value={item.Id}>{item.Name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DatePicker
              label="From-Date"
              value={dateFrom}
              onChange={handleDateFromChange}
              format="MM/YYYY"
              views={['month', 'year']}
              sx={{ backgroundColor: "white", width: 130 }}
            />
            <DatePicker
              label="To-Date"
              value={dateTo}
              onChange={handleDateToChange}
              format="MM/YYYY"
              views={['month', 'year']}
              minDate={dateFrom}
              maxDate={dateFrom ? dateFrom.add(12, 'months') : null}
              sx={{ backgroundColor: "white", width: 130 }}
            />
          </Box>
        </LocalizationProvider>

        <Tooltip title='Click to see data' arrow>
          <Button
            variant="contained"
            onClick={() => { fetchData("") }}
            sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff", borderRadius: '8px' }}
          >
            Get Data
          </Button>
        </Tooltip>

        <Tooltip title='Click to generate' arrow>
          <Button
            variant='contained'
            onClick={handleGenerateClick}
            sx={{ height: '40px', whiteSpace: 'nowrap', backgroundColor: '#635bff', borderRadius: '8px' }}
          >
            Refresh
          </Button>
        </Tooltip>
      </Box>
    </Box>
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    // navigate('/room-master');
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleLocationclick = () => {
    navigate('/masters/property');
  };

  const handleRowDoubleClick = () => {
    // console.log("hello")
  };

  return (
    <>
      <Box sx={{ maxWidth: "100vw", overflowX: "hidden" }}>
        <TableComponent
          page={page}
          columns={tableColumns}
          rows={formattedRows}
          title="Property"
          titleMaster="Bed Category Calendar"
          onCancel={handleCancel}
          handleClick={handleClick}
          FiltersJsx={Filters}
          filteredRows={filteredRows}
          handleSearchChange={handleSearchChange}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={(e) => setRowsPerPage(+e.target.value)}
          handleRowDoubleClick={handleRowDoubleClick}
          handleLocationclick={handleLocationclick}
          handleHomeClick={handleHomeClick}
          rowStyle={(row) => row.style}
          cellStyle={(columnId) =>
            columnId.startsWith('year_') || columnId.match(/^\d{4}-[A-Za-z]+$/)
              ? { padding: '2px', fontSize: '12px', textAlign: 'center' }
              : {}
          }
          isEditMode={isEditMode}
          searchTerms={searchTerms}
          pagination={pagination}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPage={pagination.pageSize}
          setIsEditMode={setIsEditMode}
          selectedRoomBedIds={selectedRoomBedIds}
          setSelectedRoomBedIds={setSelectedRoomBedIds}
          editable={false} // Disable editing for this view
          isLoading={isLoading}
        />
      </Box>
    </>
  );
}